import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FiMail, FiLock } from 'react-icons/fi';
import '../../styles/modern-login.css';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(username, password);
      toast.success('Welcome back!');
      navigate(data.user.role === 'admin' ? '/admin/dashboard' : '/user/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-login-page">
      <div className="modern-login-frame">
        <div className="modern-login-card">
          {/* Logo Icon */}
          <div className="modern-login-icon">
            <img src="/Conquerlogo.png" alt="Conquer" />
          </div>

          {/* Title */}
          <h1 className="modern-login-title">User Login</h1>

          {/* Error */}
          {error && <div className="modern-login-error">{error}</div>}

          {/* Form */}
          <form onSubmit={handleSubmit} className="modern-login-form">
            <div className="modern-input-group">
              <FiMail className="input-icon" />
              <input
                type="text"
                placeholder="Email ID"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="modern-input-group">
              <FiLock className="input-icon" />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="modern-login-btn" disabled={loading}>
              {loading ? 'Signing In...' : 'LOGIN'}
            </button>
          </form>

          <a href="/superadmin/login" className="modern-admin-link">
            Super Admin Access →
          </a>
        </div>
      </div>
    </div>
  );
}
